export const capitalizeFirstLetter = (
	str: string | null | undefined,
): string => {
	if (!str) {
		return ""; // Return an empty string if the input is falsy
	}
	return str
		.split(" ") // Split the string into words by spaces
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
		.join(" "); // Join the words back into a single string with spaces
};
